// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalContent_container__gNKVe","title":"ModalContent_title__oHT8c","list":"ModalContent_list__rg1SC","item":"ModalContent_item__5_ihE","new":"ModalContent_new__tz9lV"};